import SitePhoto from '@/components/Photo'
import type { SectionOf } from './shared'

export default function PhotoSection({ section }: { section: SectionOf<'photo'> }) {
  return (
    <figure>
      {/* 16:9 and `object-cover`. Most of the set is already 16:9; the two
          that are 3:2 lose a little floor and ceiling, which is why the crop
          is centred — these are rooms with people standing in the middle of
          them, and the interesting part is never the edge.

          It keeps 16:9 rather than taking the hero's 3:2: this one runs the
          full width of the container, so 3:2 would be 811px tall and the
          photograph would stop being a pause and start being the page. The
          *corners* do follow the hero (2026-08-26), because a 24px radius
          two sections under a 40px one reads as an oversight. */}
      <SitePhoto
        photo={section.photo}
        sizes="(min-width: 1280px) 1216px, 92vw"
        className="aspect-[16/9] w-full rounded-[2rem] object-cover sm:rounded-[2.5rem]"
      />
      {section.caption && (
        <figcaption className="mt-4 text-sm text-muted-foreground">{section.caption}</figcaption>
      )}
    </figure>
  )
}
